export const ACHIEVEMENT_BADGE_SHAPES = {
	hexagon: 'hexagon',
	square: 'square',
	circle: 'circle',
	shield: 'shield',
};
